import { connect } from 'react-redux';
import { switchOrderQueueView } from '@app/actions/orders';
import OrdersTabs from './OrdersTabs';

const mapStateToProps = state => ({
  selectedOrderQueue: state.orders.selectedOrderQueue,
});

export default connect(mapStateToProps, { switchOrderQueueView })(OrdersTabs);



// WEBPACK FOOTER //
// ./src/modules/orders/components/OrdersLayout/OrdersTabs.connect.jsx